import { Inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { ContractsFilterHelpersService } from '../../../../../features/contracts/services/contracts-filter-helpers.service'
import { CommonService } from '../../../../../core/services/common.service'
import { Observable } from 'rxjs'
import { CommonDomainComponentsActions } from './action-types'
import { concatMap, switchMap, take } from 'rxjs/operators'
import { selectAttachmentTypeScanCheckedAll, selectAttachmentTypeScanCheckedIds } from './common-domain-components.selectors'
import { ContractStateFilterActions } from '../../../../../domain/contract/components/contract-state-filter/state/action-types'
import { ExpirationDateFilterActions } from '../../../../../domain/contract/components/expiration-date-filter/state/action-types'
import { ContractValidityFilterActions } from '../../../../../domain/contract/components/contract-validity-filter/state/action-types'
import { CadastralAreaFilterActions } from '../../../../../domain/cadastral/components/cadastral-area-filter/state/action-types'
import { ContractSearchActions } from '../../../../../domain/contract/components/contract-search/state/action-types'
import { ContractGroupSearchActions } from '../../../../../domain/contract/components/contract-group-search/state/action-types'
import { SubjectSearchActions } from '../../../../../domain/subject/components/subject-search/state/action-types'

@Injectable()
export class CommonDomainComponentsEffects {

    setAttachmentTypeScanDataAttachment$: Observable<any>
    setAttachmentTypeScanDataToggleCheckSubject$: Observable<any>
    setAttachmentTypeScanDataToggleCheckAll$: Observable<any>

    constructor(@Inject(Actions) private actions$: Actions,
                @Inject(Store) private store: Store,
                @Inject(ContractsFilterHelpersService) private contractsFilterHelpersService: ContractsFilterHelpersService,
                @Inject(CommonService) private commonService: CommonService,) {

        this.setAttachmentTypeScanDataAttachment$ = createEffect(() => this.actions$.pipe(
            ofType(CommonDomainComponentsActions.setAttachmentTypeScanDataAttachment),
            switchMap((action) => {
                return this.store.select(selectAttachmentTypeScanCheckedIds).pipe(
                    take(1),
                    concatMap((checkedIds) => {
                        if (action.attachment) {
                            action.attachment.attachmentSubjects.forEach((attachmentSubject) => {
                                if (attachmentSubject.subjectId) {
                                    checkedIds.push(attachmentSubject.subjectId)
                                } else if (attachmentSubject.nonCadastralSubjectId) {
                                    checkedIds.push(attachmentSubject.nonCadastralSubjectId)
                                }
                            })

                            return [
                                CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                    property: 'checkedIds',
                                    value: checkedIds
                                }),
                                CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                    property: 'checkedAll',
                                    value: action.attachment.attachmentSubjects.length === action.ownersLength
                                }),
                                CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                    property: 'uploadedType',
                                    value: action.attachment.uploadedType
                                }),
                                CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                    property: 'attachmentId',
                                    value: action.attachment.id
                                }),
                            ]
                        } else {
                            return [
                                CommonDomainComponentsActions.noAction()
                            ]
                        }
                    })
                )
            })
        ))

        this.setAttachmentTypeScanDataToggleCheckSubject$ = createEffect(() => this.actions$.pipe(
            ofType(CommonDomainComponentsActions.setAttachmentTypeScanDataToggleCheckSubject),
            switchMap((action) => {
                return this.store.select(selectAttachmentTypeScanCheckedIds).pipe(
                    take(1),
                    concatMap((checkedIds) => {
                        this.commonService.addOrRemoveValue(checkedIds, action.id)

                        return [
                            CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                property: 'checkedIds',
                                value: checkedIds
                            }),
                            CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                property: 'checkedAll',
                                value: checkedIds.length === action.ownersLength
                            }),
                        ]
                    })
                )
            })
        ))

        this.setAttachmentTypeScanDataToggleCheckAll$ = createEffect(() => this.actions$.pipe(
            ofType(CommonDomainComponentsActions.setAttachmentTypeScanDataToggleCheckAll),
            switchMap((action) => {
                return this.store.select(selectAttachmentTypeScanCheckedAll).pipe(
                    take(1),
                    concatMap((checkedAllOld) => {
                        const checkedAll = !checkedAllOld
                        return [
                            CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                property: 'checkedIds',
                                value: checkedAll ? action.ownerIds : []
                            }),
                            CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                                property: 'checkedAll',
                                value: checkedAll
                            }),
                        ]
                    })
                )
            })
        ))
    }

    public getResetContractListFilterCriteriaActions(): any[] {
        return [
            ContractStateFilterActions.resetState(),
            ExpirationDateFilterActions.resetExistencyDate(),
            ContractValidityFilterActions.resetState(),
            CadastralAreaFilterActions.resetState(),
            ContractSearchActions.resetFilterCriteria({nonCadastralContracts: false}),
            ContractGroupSearchActions.resetSelectedContractGroup(),
            SubjectSearchActions.resetSubjectId(),
            SubjectSearchActions.resetFilterCriteria(),
        ]
    }
}